module.exports = __webpack_public_path__ + "img/data-quality-record-labels-level-3.8379c1ab.svg";